export enum AreaRating {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
}
